import type { ModalNameType, ModalPayload } from '@/modals/components/ModalProvider';
import { MODAL_DATA_PARAM, MODAL_PARAM } from '../consts';

export default function openModal<TName extends ModalNameType>(
  modalName: TName,
  ...[modalData]: ModalPayload<TName> extends void
    ? [modalData?: undefined]
    : undefined extends ModalPayload<TName>
      ? [modalData?: Exclude<ModalPayload<TName>, undefined>]
      : [modalData: ModalPayload<TName>]
): void {
  const params = new URLSearchParams();
  params.set(MODAL_PARAM, modalName);
  if (modalData != null) {
    params.set(MODAL_DATA_PARAM, JSON.stringify(modalData));
  }
  window.history.pushState({}, '', `?${params.toString()}`);
}
